import * as Sentry from "@sentry/react";
import { decrypt } from "../utils/other";
import { logoutUser } from "../utils/auth";

export const SESSION_EXPIRED_FLAG = "cy_session_expired";
export const SESSION_EXPIRED_MESSAGE =
  "Session expired, please login again.";

/**
 * Terminal session-expiry / unauthorized handler.
 *
 * With multiple login flows the old swal "Continue working?" re-login popup
 * (which POSTed to the legacy api/login/student) no longer makes sense. We now
 * simply: log the user out (clears storage + shared cookies + cy-sso
 * api/logout), leave a one-shot marker so the next page load shows a
 * "session expired" toast, then redirect to the unified login page.
 *
 * The marker survives the full-page redirect; the toast is fired on boot from
 * src/index.js (see showSessionExpiredToast).
 */
const sessionExpired = () => {
  try {
    const user = decrypt(localStorage.getItem("user")) || {};
    const username = user.email || user.studentEmail;
    if (username) {
      Sentry.captureMessage(`Session Expired:- ${username}`, "debug");
    }
  } catch (_) {
    /* ignore */
  }

  try {
    sessionStorage.setItem(SESSION_EXPIRED_FLAG, "1");
  } catch (_) {
    /* ignore */
  }

  Sentry.setUser(null);
  logoutUser();
  window.location.replace("/");
};

export default sessionExpired;
